import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/rootReducer";
import { BreadcrumbState } from "./types";

const initialState: BreadcrumbState = {
  title: "",
};

const breadcrumb = createSlice({
  name: "breadcrumbSlice",
  initialState,
  reducers: {
    setBreadcrumbTitle(state, action) {
      state.title = action.payload;
    },
  },
});
export const { setBreadcrumbTitle } = breadcrumb.actions;
export const selectBreadcrumbTitle = (state: RootState) =>
  state.breadcrumb.title;

export default breadcrumb.reducer;
